import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";

const AccordionHeaderInfoIcon = ({ title, theme, isSelected }) => {
  if (!title) return null;

  const isDarkMode =
    String(theme?.colors?.pureColor || "").toLowerCase() === "#000000";
  const iconColor =
    isDarkMode && isSelected
      ? "#ffffff"
      : theme.colors.addovation70Green;

  return (
    <Box
      component="span"
      onClick={(event) => event.stopPropagation()}
      onFocus={(event) => event.stopPropagation()}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        cursor: "default",
        lineHeight: 1,
        verticalAlign: "middle",
      }}
    >
      <InfoOutlinedIcon
        sx={{
          fontSize: "1em",
          display: "block",
          color: iconColor,
          cursor: "default",
        }}
        aria-label={title}
      />
    </Box>
  );
};

export default AccordionHeaderInfoIcon;
